import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

const inlineMessageContainerBackgroundColor = '#fff7d6';
export const InlineMessageContainer = styled.div`
    padding: ${token('space.100', '8px')} ${token('space.800', '64px')};
    display: flex;
    justify-content: center;
    background-color: ${inlineMessageContainerBackgroundColor};
`;
